import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import discountCodePercent from "../images/eshop/checkout/discount-code-percent.svg";
import discountCodeDollar from "../images/eshop/checkout/discount-code-dollar.svg";
import { connect } from "react-redux";
import { coupon } from "../models";

export class CouponMobile extends Component {
  state = {
    couponValue: ""
  };

  handleChange = event => {
    const value = event.target.value;
    this.setState({
      couponValue: value
    });
  };

  handleSubmit = () => {
    const { postCouponCode, couponErrorText } = this.props;
    const { couponValue } = this.state;
    if (couponValue.trim() === "") {
      couponErrorText(
        <Translation>{t => t("checkout.pleaseUseValidCode")}</Translation>
      );
    } else {
      postCouponCode(couponValue.trim());
      this.setState({
        couponValue: ""
      });
    }
  };

  handleDelete = data => {
    const { deleteCouponCode } = this.props;
    const code = data.couponCode;
    deleteCouponCode(code);
  };
  render() {
    const { t, myBagData, errorText, isLogin } = this.props;
    const { couponValue } = this.state;
    return (
      <React.Fragment>
        {isLogin ? (
          <div
            className="modal fade sideBarModal right headerSideBarModal"
            id="modal_discountCode"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-right" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="title_desktop_wrap d-none d-md-block">
                    <span className="title">
                      <Translation>{t => t("checkout.useCoupon")}</Translation>
                    </span>
                    <button
                      type="button"
                      className="close closeBtn"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span className="stroke" aria-hidden="true"></span>
                      <span className="stroke" aria-hidden="true"></span>
                    </button>
                  </div>

                  <div className="title_mobile_wrap d-block d-md-none">
                    <button
                      type="button"
                      className="backBtn d-block d-md-none"
                      data-dismiss="modal"
                      aria-label="Close"
                    ></button>
                    <span className="title">
                      <Translation>{t => t("checkout.useCoupon")}</Translation>
                    </span>
                  </div>
                </div>
                <div className="modal-body">
                  <div className="checkout-right_wrap right_wrap_m">
                    <div className="content">
                      <div className="checkout_discountCode_wrap">
                        <div className="title">
                          <Translation>
                            {t => t("checkout.promotionCodeVoucher")}
                          </Translation>
                        </div>

                        <div>
                          <input
                            type="text"
                            id="checkout_discountCode_m"
                            name="checkout_discountCode_m"
                            placeholder={t(
                              "checkout.enterpromotionCodeVoucher"
                            )}
                            required
                            value={couponValue}
                            onChange={this.handleChange}
                          />
                          <div className="appliedCodeTag_wrap">
                            {myBagData.coupons &&
                            Array.isArray(myBagData.coupons) ? (
                              <React.Fragment>
                                <div style={{ marginBottom: "1.5em" }}>
                                  {myBagData.coupons.map((data, index) => (
                                    <React.Fragment key={index}>
                                      {data.showUnusedCoupon ? (
                                        <span
                                          className="appliedCodeTag"
                                          key={index}
                                        >
                                          <img
                                            className="icon"
                                            src={discountCodeDollar}
                                            alt=""
                                            loading="lazy"
                                          />
                                          <span className="text">
                                            {data.couponName}
                                          </span>
                                          <button
                                            type="button"
                                            className="closeBtn"
                                            onClick={this.handleDelete.bind(
                                              this,
                                              data
                                            )}
                                          >
                                            <span
                                              className="stroke"
                                              aria-hidden="true"
                                            ></span>
                                            <span
                                              className="stroke"
                                              aria-hidden="true"
                                            ></span>
                                          </button>
                                        </span>
                                      ) : null}
                                    </React.Fragment>
                                  ))}
                                </div>
                                {myBagData.coupons.map((data, index) =>
                                  data.message ? (
                                    <p className="text-error" key={index}>
                                      {data.message}
                                    </p>
                                  ) : null
                                )}
                              </React.Fragment>
                            ) : null}
                          </div>
                          {errorText ? (
                            <p className="text-error">{errorText}</p>
                          ) : null}
                        </div>

                        <div>
                          <a className="blockBtn" onClick={this.handleSubmit}>
                            <Translation>
                              {t => t("checkout.applyNow")}
                            </Translation>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const TransCouponMobile = withTranslation()(CouponMobile);

export const mapStateToProps = state => {
  return {
    myBagData: state.myBag.myBagData,
    errorText: state.coupon.errorText,
    isLogin: state.login.signed
  };
};

export const mapDispatchToProps = () => {
  return {
    postCouponCode: code => coupon.actions.postCouponCode(code),
    deleteCouponCode: code => coupon.actions.deleteCouponCode(code),
    couponErrorText: text => coupon.actions.couponErrorText(text)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransCouponMobile);
